module.exports = __webpack_public_path__ + "img/news2-4.2e45cb2c.png";